import React, { useEffect, useRef, useState } from "react";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CustomeStyle } from "../../Css/CustomeStyle";
import Footer from "../../Fotter";
import { useDispatch, useSelector } from "react-redux";
import { GetSubCategory } from "../../redux/slices/GetSubCategorySlice";
import { toast } from "react-toastify";
import { viewCartData } from "../../redux/slices/ViewCartSlice";
import { AddToCart } from "../../redux/slices/AddTocartSlice";
import { FiShoppingCart } from "react-icons/fi";
import { clearFilterProductData } from "../../redux/slices/FilterProductSlice";
import { GetCategorySubCate } from "../../redux/slices/GetCategorySubCateSlice";
import { AddWishlist } from "../../redux/slices/AddWishlistSlice";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { GetCategoryData } from "../../redux/slices/GetCategoryDataSlice";

function ShowCategoryData() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [likedProducts, setLikedProducts] = useState(new Set());
  const { CategoryData } = useSelector((state) => state.categoryData);
  const { SubCategory } = useSelector((state) => state.getCategorySub);
  const [activeSubCategory, setActiveSubCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const { AllSubCategory } = useSelector((state) => state.subCategory);
  const { id, category } = useParams();

  useEffect(() => {
    setLoading(true);
    dispatch(GetCategoryData(category))
      .unwrap()
      .finally(() => setLoading(false));
  }, [dispatch, category]);

  useEffect(() => {
    dispatch(GetCategorySubCate(id));
  }, [id]);

  useEffect(() => {
    if (category) {
      dispatch(clearFilterProductData());
      dispatch(GetSubCategory(category));
    }
  }, [dispatch, category]);

  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const handleAddToCart = (item) => {
    const cartData = {
      productId: item?._id,
      quantity: 1,
    };

    dispatch(AddToCart(cartData))
      .then(() => {
        dispatch(viewCartData());
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
      });
  };

  const _handleGo = (subCategoryName) => {
    setLoading(true);
    dispatch(GetSubCategory(subCategoryName))
      .unwrap()
      .finally(() => setLoading(false));
    setActiveSubCategory(subCategoryName);
    navigate(`/ShowCategoryData/${category}/${id}/${subCategoryName}`);
  };

  const ProductCard = ({
    item,
    toggleLike,
    likedProducts,
    handleAddToCart,
    CustomeStyle,
  }) => {
    return (
      <div
        key={item._id}
        className="bg-white shadow rounded-md overflow-hidden relative border border-gray-200 sm:px-5 sm:py-2 px-4 py-2"
      >
        <img
          src={item?.images[0]}
          alt={item.name}
          className="w-full h-20 sm:h-40 object-contain bg-light"
        />
        <button
          className="like-btn absolute top-2 left-2"
          onClick={() => toggleLike(item._id)}
        >
          {likedProducts.has(item._id) ? (
            <FaHeart size="24px" className="text-red-500 sm:text-lg text-xs" />
          ) : (
            <FaRegHeart
              size="24px"
              className="text-gray-400 sm:text-lg md:text-xs"
            />
          )}
        </button>
        <button
          onClick={() => handleAddToCart(item)}
          className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
        >
          <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
        </button>

        <Link
          to={`/category/${item?.category ? generateSlug(item?.category) : "-"
            }/${generateSlug(item?.title)}/${generateSlug(item?._id)}`}
          state={{ item }}
          className="block no-underline"
        >
          <div>
            <h2 className="sm:text-xl text-xs text-black sm:mt-0 mt-3">
              {item.name}
            </h2>
            <h2 className="text-black text-sm md:text-base line-clamp-1 font-bold leading-none mb-1">
              {item.title}
            </h2>
            <div>
              <span className={CustomeStyle.description}>
                {item.description}
              </span>
            </div>
            <div className="mt-2 flex justify-between items-center me-2">
              <div className={`${CustomeStyle.row} space-x-1`}>
                <span className={CustomeStyle.text}>₹{item.salePrice}</span>
                <span
                  className={CustomeStyle.text}
                  style={{ textDecoration: "line-through" }}
                >
                  ₹{item.regularPrice}
                </span>
              </div>
            </div>
          </div>
        </Link>
      </div>
    );
  };

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);

    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-16647750621');
        `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex items-center w-[90%] mx-auto gap-4 sm:mt-20 mt-0">
        <button
          onClick={() => navigate(-1)}
          className=" bg-gray-200 px-2 py-2  rounded-full flex items-center mt:0 sm:mt-8"
        >
          <AiOutlineArrowLeft className="text-lg " />
        </button>
        <h2 className="text-xl font-bold mt-6 sm:mt-12">{category}</h2>
      </div>

      {(SubCategory?.length > 0 || CategoryData?.subcategories?.length > 0) && (
        <div className="w-[90%] mx-auto ">
          <div className="overflow-x-auto w-full">
            <div className="flex justify-center gap-8 w-max mx-auto  rounded-lg">
              {(SubCategory?.length > 0
                ? SubCategory
                : CategoryData?.subcategories
              )?.map((subcategory, index) => (
                <div
                  key={index}
                  onClick={() => _handleGo(subcategory?.name)}
                  className="flex-shrink-0 flex flex-col items-center cursor-pointer"
                >
                  <div className="flex items-center justify-center w-36 h-12 rounded-3xl bg-gray-300">
                    <p className="text-center font-medium text-black text-sm px-2 line-clamp-1 mt-3">
                      {subcategory.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {activeSubCategory && (
        <h2 className="w-[90%] mx-auto text-xl font-bold  sm:px-20 sm:p-5 p-0 mt-3 px-6">
          {activeSubCategory ? activeSubCategory : ""}
        </h2>
      )}

      <div className="w-[90%] mx-auto flex flex-col md:flex-row gap-8 justify-center  mb-[3%] mt-4 ">
        <div className="w-full sm:w-[95%] md:w-[100%] mt-0 ">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-1 lg:gap-3">
            {/* {AllSubCategory?.data?.length > 0 ? (
              AllSubCategory.data.map((item) => (
                <ProductCard
                  key={item._id}
                  item={item}
                  toggleLike={toggleLike}
                  likedProducts={likedProducts}
                  handleAddToCart={handleAddToCart}
                  CustomeStyle={CustomeStyle}
                />
              ))
            ) : CategoryData?.data?.length > 0 ? (
              CategoryData.data.map((item) => (
                <ProductCard
                  key={item._id}
                  item={item}
                  toggleLike={toggleLike}
                  likedProducts={likedProducts}
                  handleAddToCart={handleAddToCart}
                  CustomeStyle={CustomeStyle}
                />
              ))
            ) : (
              <div className="flex justify-center items-center h-[200px] w-full sm:ms-96 ms-20">
                <p className="text-center text-lg font-semibold">
                  No Product Found
                </p>
              </div>
            )} */}
            {loading ? (
              <div className="flex justify-center items-center h-[200px] w-full">
                <p className="text-center text-lg font-semibold">Loading...</p>
              </div>
            ) : AllSubCategory?.data?.length > 0 ? (
              AllSubCategory.data.map((item) => (
                <ProductCard
                  key={item._id}
                  item={item}
                  toggleLike={toggleLike}
                  likedProducts={likedProducts}
                  handleAddToCart={handleAddToCart}
                  CustomeStyle={CustomeStyle}
                />
              ))
            ) : CategoryData?.data?.length > 0 ? (
              CategoryData.data.map((item) => (
                <ProductCard
                  key={item._id}
                  item={item}
                  toggleLike={toggleLike}
                  likedProducts={likedProducts}
                  handleAddToCart={handleAddToCart}
                  CustomeStyle={CustomeStyle}
                />
              ))
            ) : (
              <div className="flex justify-center items-center h-[200px] w-full">
                <p className="text-center text-lg font-semibold">
                  No Product Found
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ShowCategoryData;
